
export const all = (state) => {
  return state
}



// WEBPACK FOOTER //
// ./src/store/modules/components/getters.js